import { render } from "./saleAfterService.vue?vue&type=template&id=31fffa93&scoped=true"
import script from "./saleAfterService.vue?vue&type=script&lang=js"
export * from "./saleAfterService.vue?vue&type=script&lang=js"

import "./saleAfterService.vue?vue&type=style&index=0&id=31fffa93&lang=css"
import "./saleAfterService.vue?vue&type=style&index=1&id=31fffa93&scoped=true&lang=css"

import exportComponent from "/root/workspace/cinema-admin_TXA8/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31fffa93"]])

export default __exports__